import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Form, FormGroup, FormInput, FormSelect, FormTextarea, Button, Alert, FormCheckbox, Badge, CardBody } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import { Store } from "../flux";
import Apps from "./Apps";

const AreaAPIDetails = props => {

    const [ Details, SetDetails ] = useState({});
    const [ AreaApps, SetAreaApps ] = useState([]);
    const [ ShowAlert, SetShowAlert ] = useState(false);
    const [ AlertToShow, SetAlertToShow ] = useState(null);

    useEffect(() => {

        const setData = async () => {

            SetDetails(props.Area);

            let AreaApps = [];

            props.Area.api_details && await props.Area.api_details.map(AreaApp => {

                AreaApps.push(AreaApp.app_id);
            });

            SetAreaApps(AreaApps);
        }

        setData();
    }, [ props.Area ]);

    const updateAPIURL = async (APIDetailsID, APIURL) => {

        const UpdateData = JSON.stringify({ id: APIDetailsID, api_url: APIURL });
        await fetch("https://app-centre.tascomi.com/app-centre.php?end_point=update_api_details&data=" + UpdateData);
        await Store.retrieveApps();
        await Store.retrieveAreas();

        await SetAlertToShow(APIDetailsID);
        await SetShowAlert(true);

        setTimeout(() => {

            SetShowAlert(false);
        }, 2000);
    }

    const addApp = async(e) => {

        const AppID = e.target.value;

        if (AppID !== "all") {

            const TempAPIDetail = {

                api_url: "",
                app_icon_url: props.Apps.filter(App => App.id === AppID)[0].app_icon_url,
                app_id: AppID,
                app_name: props.Apps.filter(App => App.id === AppID)[0].name,
                area_id: props.Area.id
            };

            props.AddApp(TempAPIDetail);

            const AreaID = props.Area.id;

            const AddData = JSON.stringify({ app_id: AppID, area_id: AreaID });

            await fetch("https://app-centre.tascomi.com/app-centre.php?end_point=add_api_detail&data=" + AddData);
            await Store.retrieveApps();
            await Store.retrieveAreas();

            // await SetAlertToShow(APIDetailsID);
            await SetShowAlert(true);

            setTimeout(() => {

                SetShowAlert(false);
            }, 2000);
        }

        // if (AppID !== "all") {


        // }
    }

    const removeAPIDetail = async (APIDetailID, APIDetailIndex) => {

        props.RemoveApp(APIDetailIndex);
        const Data = JSON.stringify({ id: APIDetailID });

        await fetch("https://app-centre.tascomi.com/app-centre.php?end_point=remove_api_detail&data=" + Data);
        await Store.retrieveApps();
        await Store.retrieveAreas();
    }

	return (
        <>
		    {/* Page Header */}
            <Row noGutters className="page-header py-4">

                <Col className="col-10">
                    <PageTitle sm="4" title="View" subtitle="Area Apps" className="text-sm-left" />
                </Col>
                <Col className="col-2">
                    <FormSelect id="filter_by_app_name" onChange={ (e) => addApp(e) }>
                        <option value="all">+ Add App</option>
                        { props.Apps.map((App, Index) => {

                            return !AreaApps.includes(App.id) && <option key={ Index } value={ App.id }>{ App.name }</option>;
                        })}
                    </FormSelect>
                </Col>
            </Row>
            <Row>
                { props.Area.api_details !== false && props.Area.api_details.map((API, Index) => {

                    return (

                        <Col lg="4" md="6" sm="12" className="mb-4" key={ Index }>
                            <Card small className="card-post card-post--1" style={{ height: "" }}>
                                <CardBody>
                                    <a href="#" className="card-post__author-avatar card-post__author-avatar--small" style={{ padding: "1.5rem", backgroundColor: "white", marginTop: "-1rem", marginBottom: "1rem", backgroundImage: `url('${ API.app_icon_url }')` }} />

                                    <h5 className="card-title">
                                        <a href="#" className="text-fiord-blue">{ API.app_name }</a>
                                    </h5>
                                    <hr />
                                    <label htmlFor="api_url">API URL</label>
                                    <FormInput id="api_url" placeholder="Area API Url" value={ API.api_url } onChange={ (e) => { props.Change(e.target.value, e.target.id, Index)} } />

                                    <br />
                                    <Button onClick={ () => updateAPIURL(API.api_details_id, API.api_url) } className="btn-primary">{ API.api_url !== "" ? "Update" : "Save" }</Button>
                                    &nbsp;&nbsp;
                                    <Button onClick={ (e) => removeAPIDetail(API.api_details_id, Index) } outline className="btn-outline-danger">Remove</Button>

                                    { (ShowAlert && AlertToShow === API.api_details_id) &&
                                        <>
                                            <br /><br />
                                            <Alert className="alert-success alert-dismissible fade show mb-0" role="alert">
                                                <i className="fa fa-check mx-2"></i>
                                                <strong>Success!</strong> API URL has been updated.
                                            </Alert>
                                        </>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
        </>
	);
}

export default AreaAPIDetails;
